/**
 * User Type Definitions
 */

export enum UserRole {
  OPERATIONS = 'operations',
  ADMIN = 'admin',
}

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.OPERATIONS]: 'Operações',
  [UserRole.ADMIN]: 'Administrador',
};

export interface CreateUserData {
  email: string;
  password: string;
  fullName: string;
  role: UserRole;
}

export interface UpdateUserData {
  email?: string;
  password?: string;
  fullName?: string;
  role?: UserRole;
}
